/**
 * Client-side API implementation
 * This allows the site to run without a backend server for Cloudflare Pages
 */

// Type definitions
interface SubscribeResponse {
  success: boolean;
  message: string;
  data?: any; // Optional data field to handle API responses
}

/**
 * Function to subscribe a user to the newsletter
 * In production, this will use the Beehiiv API through Cloudflare Functions
 */
export async function subscribeToNewsletter(email: string): Promise<SubscribeResponse> {
  try {
    // Determine which API endpoint to use based on environment
    const apiUrl = '/api/subscribe'; // Always use the relative path for Cloudflare Pages Functions

    console.log('Using API endpoint:', apiUrl);

    const response = await fetch(apiUrl, {
      method: 'POST',  // Ensure we're using POST method
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        email
        // The following fields will be handled by the server-side function
        // to ensure API security and consistency
      })
    });

    console.log('API response status:', response.status);

    // Try to parse the response JSON first
    let data: SubscribeResponse;
    try {
      data = await response.json();
      console.log('API response data:', data);
    } catch (e) {
      // If we can't parse the JSON, create a generic error response
      console.error('Failed to parse API response:', e);
      return {
        success: false,
        message: 'Unable to process your subscription. Please try again later.'
      };
    }

    // Check if the response is OK
    if (!response.ok) {
      console.error(`API error: ${response.status}`, data);

      // If we have a message from the API, use it
      if (data && data.message) {
        return data;
      }

      // Otherwise return a generic error
      return {
        success: false,
        message: `Subscription error (${response.status}). Please try again later.`
      };
    }

    return data;
  } catch (error) {
    console.error('Error in subscription process:', error);
    return {
      success: false,
      message: 'Unable to process your subscription at this time. Please try again later.'
    };
  }
}